<template>
  <v-layout wrap>
    <v-flex sm3 md3 lg3 xl3>
      <v-select
        :items="getActivePlantInfo(['rule', 'comp_config', 'alert', 'options', 'deviceList'])"
        item-text="text"
        item-value="value"
        v-model="typeChange"
        label="Type of Alert"
        solo
        return-object
        @input="$emit('change:device', typeChange.value)"
      >
        <template slot="selection" slot-scope="{ item, index }">
          <span v-if="index < fitCount" :style="{fontSize: '14px'}">{{ item.text }}</span>
        </template>
      </v-select>
    </v-flex>
    <v-flex sm3 md3 lg3 xl3>
      <v-select
        :items="severityList"
        item-text="text"
        item-value="value"
        v-model="severity"
        label="Severity"
        solo
        @input="$emit('change:severity', severity)"
      >
        <template slot="selection" slot-scope="{ item, index }">
          <span v-if="index < fitCount" :style="{fontSize: '14px'}">{{ item.text }}</span>
        </template>
      </v-select>
    </v-flex>
    <v-flex sm3 md3 lg3 xl3>
      <el-date-picker
        class="date-picker"
        :picker-options="pickerOptions"
        v-model="full_date"
        @input="$emit('change:date',full_date)"
        type="daterange"
        align="right"
        format="yyyy-MM-dd"
        unlink-panels
        size="large"
        value-format="yyyy-MM-dd"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        id="date-picker"
      ></el-date-picker>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex sm2 md2 lg2 xl2>
      <v-btn color="success" v-on:click="downloadAlertList()" class="download-button" large>Download</v-btn>
    </v-flex>
    <v-btn color="primary" @click="openDialog" large>
      Add Alert
    </v-btn>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" scrollable max-width="500px">
        <v-form id='alertCreateForm'>
          <v-card>
            <v-card-title>
              <span class="headline">
                Manual Alert
              </span>
            </v-card-title>
            <v-card-text style="height: 300px; overflow-y: auto" class="scroll-overflow">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-menu
                      v-model="timeMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="manualAlert.currentTime"
                        label="Start Time*"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker
                        v-model="manualAlert.currentTime"
                        full-width
                        @click:minute="$refs.menu.save(manualAlert.currentTime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      v-model="dateMenu"
                      :close-on-content-click="true"
                      :nudge-right="0"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width min-width="290px"
                    >
                      <v-text-field slot="activator" v-model="manualAlert.currentDate" label="Start Date*" prepend-icon="event" readonly></v-text-field>
                      <v-date-picker v-model="manualAlert.currentDate" @input="dateMenu = false" ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      prepend-icon="smartphone"
                      :items="['computed']"
                      v-model="manualAlert.equipment"
                      label="Equipment*"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      prepend-icon="chat"
                      label="Message*"
                      auto-grow
                      row-height=10
                      no-resize
                      v-model="manualAlert.reason"
                      hint="Alert Message"
                      required>
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      prepend-icon="warning"
                      :items="['Manual Alert', 'Dip Reason']"
                      v-model="manualAlert.code"
                      label="Code*"
                      required
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">Cancel</v-btn>
              <v-btn color="blue darken-1" type="button" flat @click="dialog = false; createMAlert()" :disabled="disableBtn">Send</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>
<script>
import moment from 'moment'
import { EventBus } from '@/services/event-bus'
import { mapGetters, mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
var mqtt = require('mqtt')

export default {
  props: ['list'],
  data() {
    return {
      manualAlert: this.currentData(),
      timeMenu: false,
      dateMenu: false,
      dialog: false,
      severityList: [
        {
          text: 'Critical',
          value: 'critical'
        },
        {
          text: 'High',
          value: 'high'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Warning',
          value: 'warning'
        },
        {
          text: 'Info',
          value: 'modbus'
        }
      ],
      severity: 'critical',
      typeChange: 'inverter',
      full_date: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      pickerOptions: {
        disabledDate(date) {
          const currentDate = moment()
          if (date > currentDate) return true
          else if (Math.abs(moment(date).diff(currentDate, 'days')) > 90) { return true } else return false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getActivePlantInfo', 'getSelectedPlantId']),
    fitCount() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 1
        case 'sm':
          return 1
        case 'md':
          return 2
        case 'lg':
          return 3
        case 'xl':
          return 3
      }
    },
    ref_id: function () {
      return uuidv4()
    },
    disableBtn: function () {
      let { currentDate, currentTime, equipment, code, reason } = this.manualAlert
      if (reason.trim().length <= 0 ||
          currentTime.trim().length <= 0 ||
          currentDate.trim().length <= 0 ||
          code.trim().length <= 0 ||
          equipment.trim().length <= 0
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_SHOW_SNACKBAR',
      'SET_SNACKBAR_CONTENT'
    ]),
    downloadAlertList() {
      EventBus.$emit('downloadAlert')
    },
    createMAlert() {
      let { currentDate, currentTime, equipment, code, reason } = this.manualAlert
      const unixTime = moment(`${currentDate} ${currentTime}`, 'YYYY-MM-DD HH:mm').format('X')
      let query = {
        plant_id: this.getSelectedPlantId,
        ref_id: uuidv4(),
        sensor_time: unixTime,
        status: 'new',
        severity: 99,
        scope: 'MA', // Manual Alert
        logic: 'secondary',
        equipment_id: 1,
        created_timestamp: unixTime,
        created_date: currentDate,
        equipment: equipment,
        code: code,
        message: reason
      }

      this.$mqtt.publish('/alert/live', JSON.stringify(query))
      let payload = {
        icon: 'success',
        header: '',
        message: 'Alert Successfully Created'
      }
      this.SET_SNACKBAR_CONTENT(payload)
      this.SET_SHOW_SNACKBAR(true)
      this.manualAlert = this.currentData()
    },
    currentData() {
      return {
        currentTime: '',
        currentDate: '',
        reason: '',
        code: '',
        equipment: ''
      }
    },
    openDialog() {
      this.dialog = true
    }
  }
}
</script>

<style scoped>
  .date-picker {
    height: 49px;
  }

  .download-button {
    margin-top: 2px;
  }

</style>
